async function getReservations(API_BASE, token, filters = {}) {
    const headers = {
        "Authorization": `Bearer ${token}`,
    };

    const params = new URLSearchParams();
    if (filters.code_etablissement) params.append("code_etablissement", filters.code_etablissement);
    if (filters.item_id) params.append("item_id", filters.item_id);
    if (filters.user_id) params.append("user_id", filters.user_id);

    const res = await fetch(`${API_BASE}/reservations?${params.toString()}`, {
        method: "GET",
        headers,
    });

    if (!res.ok) {
        throw new Error(await res.text());
    }

    return await res.json();
}
export default getReservations;
